/**
 * Thrown when something attempts to access properties or methods that require the application to
 * be running.
 */
export default class ApplicationNotStartedError extends Error {

    /**
     * Creates a new instance of ApplicationNotStartedError
     * @param {string} applicationName The name of the application that threw the error
     */
    constructor(applicationName) {
        super(`${applicationName} has not been started. You must call Application.start() before accessing this property or using calling method.`);

        this.applicationName = applicationName;
    }
}


// WEBPACK FOOTER //
// ./source/framework/errors/ApplicationNotStartedError.js